import script from "./LoginForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginForm.vue?vue&type=script&lang=ts&setup=true"

import "./LoginForm.vue?vue&type=style&index=0&id=2590fdfd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2590fdfd"]])

export default __exports__